export const TITULO_DIALOG_EXLUSAO = 'Excluir fazenda';
export const TEXTO_DIALOG_EXLUSAO =
  'Deseja realmente excluir a fazenda <nome>?';
